module.exports = __webpack_public_path__ + "static/media/avatars_male_13.7458f16b.png";